import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { withNamespaces } from "react-i18next";
import { AppState } from "src/redux/store";
import { getProject, getPrestation } from "src/redux/projects/selectors";
import { connect } from "react-redux";

const mapStateToProps = (state: AppState, props) => {
  return {
    project: getProject(state.projects, {
      projectId: +props.match.params.id
    }),
    prestation: getPrestation(state.projects, {
      projectId: +props.match.params.id,
      prestationId: +props.match.params.prestationId
    })
  };
};

class Breadcrumbs extends React.Component<any> {
  // Divide url in many part if find a slash

  getPaths = pathname => {
    const paths = ["/"];
    if (pathname === "/") {
      return paths;
    }
    pathname.split("/").reduce((prev, curr) => {
      const currPath = `${prev}/${curr}`;
      paths.push(currPath);
      return currPath;
    });
    return paths;
  };
  BreadcrumbsItem = (match, index, breadcrumbsRoute) => {
    const routeName = breadcrumbsRoute.find(i =>
      // if proposal's route was found, don't use regex because proposal has an Uuid
      match.search("/proposal/") && match.search("/proposal/") > 0
        ? i.path === "/projects/:id/prestation/:id/proposal/:Uuid"
        : i.path === match.replace(/\d+/g, ":id")
    );
    if (routeName) {
      return (
        <BreadcrumbItem key={index}>
          <Link
            to={{
              pathname: match || ""
            }}
          >
            {routeName.breadcrumb}
          </Link>
        </BreadcrumbItem>
      );
    }
    return null;
  };
  render() {
    const { location } = this.props as any;
    const paths = this.getPaths(location.pathname);
    /**
     * List all route want to display in breadcrumb
     */
    const breadcrumbsRoute = [
      {
        path: `/projects`,
        breadcrumb: this.props.t("breadcrumbs.route.projects")
      },
      {
        path: `/projects/:id`,
        breadcrumb:
          this.props.project &&
          location.pathname !== `/projects/${this.props.project.id}`
            ? this.props.project.name
            : this.props.t("breadcrumbs.route.project")
      },
      {
        path: `/projects/:id/prestation/:id/proposal/:Uuid`,
        breadcrumb: this.props.t("breadcrumbs.route.proposal")
      },
      {
        path: `/projects/:id/prestation/:id`,
        breadcrumb:
          this.props.project &&
          this.props.prestation &&
          location.pathname !==
            `/projects/${this.props.project.id}/prestation/${
              this.props.prestation.id
            }`
            ? this.props.prestation.name
            : this.props.t("breadcrumbs.route.proposals")
      },
      {
        path: `/library`,
        breadcrumb: this.props.t("breadcrumbs.route.library")
      },
      {
        path: `/library/projects/:id`,
        breadcrumb: this.props.t("breadcrumbs.route.medias")
      },
      {
        path: `/store`,
        breadcrumb: this.props.t("breadcrumbs.route.store")
      },
      {
        path: `/account`,
        breadcrumb: this.props.t("breadcrumbs.route.account")
      },
      {
        path: `/profil`,
        breadcrumb: this.props.t("breadcrumbs.route.profil")
      }
    ];
    return (
      <Breadcrumb>
        {paths.map((p, index) =>
          this.BreadcrumbsItem(p, index, breadcrumbsRoute)
        )}
      </Breadcrumb>
    );
  }
}

export default withNamespaces()(withRouter(
  connect(mapStateToProps)(Breadcrumbs)
) as any);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.tsx